import { useEffect, useState } from "react";
import FormInput, { FormProps } from "../input/FormInput";
import { Input, InputWrapper, UnitLabel } from "./unitLabelledInput.style";

export interface IUnitLabelledInputprops extends FormProps {
  unitLabel: string;
  unitLabelOptions?: string[];
  mask?: string;
}

const UnitLabelledInput = (props: IUnitLabelledInputprops) => {
  function isEmpty(value: string) {
    if (!value) return true;
    const val = value.split(", ");
    if (!val[0] && val[1]) {
      return true;
    } else {
      return false;
    }
  }
  const fieldValue =
    props.value && !isEmpty(props.value)
      ? props.value.split(", ")
      : ["", props.unitLabel];

  const [value, setValue] = useState(fieldValue);

  useEffect(() => {
    const val =
      props.value && !isEmpty(props.value)
        ? props.value.split(", ")
        : ["", props.unitLabel];
    setValue(val);
  }, [props.value]);

  const selectDisabled =
    props.disabled ||
    !value[0] ||
    !(props.unitLabelOptions && props.unitLabelOptions.length > 0);

  function onToggleCheck() {
    if (props.setFieldValue && props.name) {
      props.setFieldValue(props.name, "");
    }
  }

  function getMaskedValue(value: string, mask: string): string {
    if (!mask) return value;
    const cleanValue = value.replace(/[^\d]/g, "");
    let i = 0;
    let lastReplacedIndex = -1;
    const filledMask = mask.replace(/#/g, (_, j) => {
      if (i >= cleanValue.length) {
        return "#";
      }
      lastReplacedIndex = j;
      return cleanValue[i++];
    });
    return filledMask.substring(0, lastReplacedIndex + 1);
  }

  function onInputChange(e: any) {
    const enteredValue = props.mask
      ? getMaskedValue(e.target.value, props.mask)
      : e.target.value;
    let newValue = [enteredValue, value[1]];
    if (props.setFieldValue && props.name) {
      props.setFieldValue(props.name, newValue.join(", "));
      if (props.toggleBoxName) {
        !!newValue[0].length && props.setFieldValue(props.toggleBoxName, false);
      }
    }
    if (isEmpty(newValue.join(", ")) && props.setFieldValue && props.name) {
      props.setFieldValue(props.name, "");
      newValue = ["", props.unitLabel];
    }
    setValue(newValue);
  }

  function onSelect(e: any) {
    const newValue = [value[0], e.target.value];
    if (props.setFieldValue && props.name) {
      props.setFieldValue(props.name, newValue.join(", "));
      if (props.toggleBoxName) {
        newValue[1] !== value[1] &&
          props.setFieldValue(props.toggleBoxName, false);
      }
    }
    setValue(newValue);
  }
  return (
    <FormInput
      {...props}
      name={props.name}
      setFieldValue={props.setFieldValue}
      onCheck={props.onCheck || onToggleCheck}
    >
      <InputWrapper>
        <Input
          data-testid={`input-${props.name}`}
          name={props.name}
          onChange={onInputChange}
          placeholder={props.placeholder}
          value={value[0]}
          onBlur={props.onBlur}
          disabled={props.disabled || props.toggleBoxValue}
        />
        <UnitLabel
          data-testid={`unit-label-${props.name}`}
          disabled={selectDisabled || props.toggleBoxValue}
          name={props.name}
          onChange={onSelect}
          value={value[1]}
        >
          <option value={props.unitLabel}>{props.unitLabel}</option>
          {props.unitLabelOptions &&
            props.unitLabelOptions.map((unit) => (
              <option key={unit} value={unit}>
                {unit}
              </option>
            ))}
        </UnitLabel>
      </InputWrapper>
    </FormInput>
  );
};

export default UnitLabelledInput;
